export const UI_VERSION: string = process.env.REACT_APP_BUILD_ID || process.env.REACT_APP_VERSION || '0';
export const APP_INSIGHTS_KEY: string = process.env.REACT_APP_APP_INSIGHTS_KEY || '';
